export default class GetCategoriasByTipoCurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idTipoCurso) {
    try {
      const result = await this.#repository.getCategoriasByTipoCurso(idTipoCurso)
      return result
    } catch (error) {
      throw error
    }
  }
}
